import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Mianshi = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 20 20"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="c73cd__a">
              <rect
                rx="0"
                height="20"
                width="20"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#c73cd__a)"
            fill="#F76560"
          >
            <path
              d="M12.917 4.583q0 .144-.014.286-.014.143-.042.283-.028.14-.07.278-.041.137-.096.27-.055.132-.123.258-.067.127-.147.246-.08.119-.17.23-.091.11-.193.212-.1.101-.212.192-.11.09-.23.17-.119.08-.245.148-.126.067-.259.122-.132.055-.27.096-.136.042-.277.07-.14.028-.283.042-.143.014-.286.014t-.286-.014q-.142-.014-.283-.042-.14-.028-.278-.07-.137-.041-.27-.096-.131-.055-.258-.122-.126-.068-.245-.148-.12-.08-.23-.17-.111-.09-.212-.192-.102-.102-.193-.212-.09-.111-.17-.23-.08-.12-.147-.246-.068-.126-.123-.258-.054-.133-.096-.27t-.07-.278q-.028-.14-.042-.283-.014-.142-.014-.286 0-.143.014-.286.014-.142.042-.283.028-.14.07-.277.042-.137.096-.27.055-.132.123-.259.067-.126.147-.245.08-.12.17-.23.091-.11.193-.212.101-.101.212-.192.11-.091.23-.17.119-.08.245-.148.127-.067.259-.122.132-.055.27-.097.136-.041.277-.07.14-.027.283-.041.143-.014.286-.014t.286.014q.143.014.283.042.14.028.278.07.137.04.27.096.132.055.258.122.126.068.245.147.12.08.23.17.111.092.212.193.102.101.193.212.09.11.17.23.08.12.147.245.068.127.123.26.055.132.096.269.042.137.07.277.028.14.042.283.014.143.014.286Z"
              data-follow-fill="#F76560"
              fill={_fill}
            />
            <path
              fillRule="evenodd"
              d="M12.504 7.088q1.038-1.038 1.038-2.505 0-1.467-1.038-2.504Q11.467 1.042 10 1.042T7.496 2.079Q6.458 3.116 6.458 4.583t1.038 2.505Q8.533 8.125 10 8.125t2.504-1.037Zm-.884-4.125q.672.671.672 1.62 0 .95-.672 1.62-.67.672-1.62.672-.95 0-1.62-.671-.672-.671-.672-1.62 0-.95.672-1.621.67-.671 1.62-.671.95 0 1.62.67Zm-7.341 9.873q2.019-1.794 4.888-1.794a.625.625 0 1 0 0-1.25q-3.345 0-5.719 2.11-2.406 2.14-2.406 5.181a.625.625 0 0 0 1.25 0q0-2.48 1.987-4.247Z"
              data-follow-fill="#F76560"
              fill={_fill}
            />
            <path
              d="M17.083 14.167q0 .123-.012.245t-.036.242q-.024.12-.06.238-.035.118-.082.231-.047.114-.105.222-.058.108-.126.21-.068.103-.146.198-.078.095-.165.181-.087.087-.182.165-.095.078-.197.146-.102.069-.21.126-.108.058-.222.105-.113.047-.23.083-.118.036-.239.06-.12.024-.243.036-.122.012-.245.012-.122 0-.245-.012-.122-.012-.242-.036-.12-.024-.238-.06t-.231-.083q-.114-.047-.222-.105-.108-.057-.21-.126-.103-.068-.198-.146-.095-.078-.181-.165-.087-.086-.165-.181-.078-.095-.146-.197-.069-.103-.126-.21-.058-.11-.105-.223-.047-.113-.083-.23-.036-.118-.06-.239-.024-.12-.036-.242-.012-.122-.012-.245t.012-.245q.012-.123.036-.243.024-.12.06-.238t.083-.231q.047-.113.105-.222.057-.108.126-.21.068-.102.146-.197.078-.095.165-.182.086-.087.181-.165.095-.078.197-.146.103-.068.21-.126.11-.058.223-.105.113-.047.23-.083.118-.035.239-.06.12-.023.242-.035.123-.012.245-.012.123 0 .245.012.123.012.243.036.12.024.238.06.118.035.231.082.114.047.222.105.108.058.21.126t.197.146q.095.078.182.165.087.087.165.182.078.095.146.197.068.102.126.21.058.109.105.222.047.113.083.231.035.118.06.238.023.12.035.243.012.122.012.245Z"
              data-follow-fill="#F76560"
              fill={_fill}
            />
            <path
              fillRule="evenodd"
              d="M16.793 16.376q.915-.915.915-2.21 0-1.294-.915-2.209t-2.21-.915q-1.294 0-2.21.915-.915.915-.915 2.21 0 1.294.916 2.21.915.915 2.21.915 1.294 0 2.21-.916Zm-.884-3.535q.55.549.55 1.326 0 .776-.55 1.326-.549.549-1.326.549-.776 0-1.325-.55-.55-.549-.55-1.325 0-.777.55-1.326.549-.55 1.325-.55.777 0 1.326.55Z"
              data-follow-fill="#F76560"
              fill={_fill}
            />
            <path
              fillRule="evenodd"
              d="M17.958 17.583c.108.081.24.125.375.125h.006a.626.626 0 0 0 .62-.625l-.001-.024a.625.625 0 0 0-.25-.476l-1.666-1.25a.625.625 0 0 0-.375-.125h-.024a.625.625 0 0 0-.601.625v.024a.625.625 0 0 0 .25.476l1.666 1.25Z"
              data-follow-fill="#F76560"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
